import amplitude from 'amplitude-js'
import cookie from '@/utils/cookie'
import { getAmplitudeKey } from '@/environments'

export default {
  amplitudeInit () {
    amplitude.getInstance().init(getAmplitudeKey())
    if (cookie.get('user')) {
      const { id } = JSON.parse(cookie.get('user'))
      if (id) {
        amplitude.setUserId(id)
      }
    }
  },
  onboardingFlow (toPage, fromPage) {
    this.amplitudeInit()
    amplitude.logEvent(`Enter_Page_${toPage.name}`)
    amplitude.logEvent('ONBOARDING_FLOW', {
      toPage: toPage.name || 'Blank',
      fromPage: fromPage.name || 'Blank'
    })
  },
  inputField (inputName, isValid, eventType) {
    this.amplitudeInit()
    let eventProp = {inputName}
    if (typeof isValid !== 'undefined') eventProp.isValid = isValid // isValid is undefined when inputName is't required validate
    amplitude.logEvent(eventType, eventProp)
  },
  inputQuestion (eventType, eventProp) {
    amplitude.logEvent(eventType, eventProp)
  },
  axiosResponseError (error) {
    this.amplitudeInit()
    let eventProp = {}
    if (error.response) {
      const response = error.response
      eventProp.statusCode = response.status
      eventProp.statusText = response.statusText
      eventProp.message = response.data.message
      eventProp.method = response.config.method
      eventProp.url = response.config.url
    } else {
      eventProp.message = error.message
      eventProp.statusCode = error.code
      if (error.config) {
        eventProp.method = error.config.method
        eventProp.url = error.config.url
      }
    }
    amplitude.logEvent(`EVENT_AXIOS_RESPONSE_ERROR`, eventProp)
  },
  vuejsHandlerError (err, vm, info) {
    this.amplitudeInit()
    let eventProp = {
      error: err.toString(),
      info
    }
    const errorInComponent = vm.$vnode && vm.$vnode.tag
    if (errorInComponent) {
      eventProp.errorInComponant = errorInComponent
    }
    amplitude.logEvent(`EVENT_VUEJS_ERROR`, eventProp)
    if (process.env.ENV === 'development') {
      console.log('Vue.js error==>', eventProp)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/amplitude/index.js